if (!customElements.get('color-variants-gallery')) {
    customElements.define(
        'color-variants-gallery',
        class SwiperGallery extends HTMLElement {
            constructor() {
                super();

                this.selectors = {
                    thumbnailSlider: '.thumbs-swiper',
                    thumbnailSliderItems: '.thumbs-swiper .swiper-slide',
                    gallerySlider: '.gallery-swiper',
                    mediaItems: ['.product__gallery-item'],
                    colorSelection: 'variant-selects label',
                };

                this.thumbsSelector = this.selectors.thumbnailSlider;
                this.colorSelection = this.selectors.colorSelection;
                this.gallerySelector = this.selectors.gallerySlider;

                this.sliderInstance = false;
                this.thumbsInstance = false;
                this.isZoomInitialized = false;

                this.initThumbsSwiper();
                this.initGallerySwiper();
                this.setupThumbClickHandlers();
                this.loadAccessories();

            }

            connectedCallback() {
                this.observeNavigation();
                setTimeout(() => {
                    this.videoPlayButton();
                    this.initImageZoom();
                }, 500);
            }

            observeNavigation() {
                const runZoom = () => {
                    // Sadece ürün sayfalarında çalışsın
                    if (!window.location.pathname.includes('/products/')) return;

                    this.isZoomInitialized = false;
                    this.initImageZoom();
                };

                // pushState / replaceState sadece bir kere override edilsin
                if (!window._locationChangePatched) {
                    ['pushState', 'replaceState'].forEach((method) => {
                        const original = history[method];
                        history[method] = function () {
                            const result = original.apply(this, arguments);
                            window.dispatchEvent(new Event('locationchange'));
                            return result;
                        };
                    });
                    window._locationChangePatched = true;
                }

                // Event listener sadece bir kere eklenmişse tekrar ekleme
                if (!window._zoomNavigationListenerAttached) {
                    if (window.navigation?.addEventListener) {
                        window.navigation.addEventListener("navigate", runZoom);
                    } else {
                        window.addEventListener('popstate', runZoom);
                        window.addEventListener('locationchange', runZoom);
                    }
                    window._zoomNavigationListenerAttached = true;
                }
            }

            loadAccessories() {
                setTimeout(() => {
                    const accessories = document.querySelector(".accessories");
                    if (accessories) {
                        accessories.style.opacity = '1';
                    }
                }, 500);
            }

            initImageZoom() {
                if (this.isZoomInitialized) return;
                this.isZoomInitialized = true;

                const galleryWrapper = this.closest('.gallery-swiper') || document;
                const allMedia = [...galleryWrapper.querySelectorAll('.product__gallery-item')]
                    .filter((el) => getComputedStyle(el).display !== 'none');
                let dataSource = allMedia.map((media) => {
                    const mediaType = media.dataset.mediaType;
                    const index = media.dataset.mediaIndex;

                    switch (mediaType) {
                        case 'model':
                            return {
                                id: index,
                                html: `<div class="pswp__item--${mediaType}">${media.querySelector('product-model')?.outerHTML || ''}</div>`,
                                mediaType
                            };
                        case 'video':
                        case 'external_video':
                            return {
                                id: index,
                                html: `<div class="pswp__item--${mediaType}">${media.querySelector('media-controller')?.outerHTML || ''}</div>`,
                                mediaType
                            };
                        case 'image':
                            return {
                                id: index,
                                src: media.dataset.src,
                                width: media.dataset.pswpWidth,
                                height: media.dataset.pswpHeight,
                                mediaType
                            };
                        case 'eko':
                            return {
                                id: index,
                                html: `<div class="pswp__item--${mediaType}">${media.querySelector('iframe')?.outerHTML || ''}</div>`,
                                mediaType
                            };
                        default:
                            return null;
                    }
                }).filter(Boolean);

                this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
                    dataSource,
                    pswpModule: window.FoxTheme.PhotoSwipe,
                    bgOpacity: 1,
                    arrowPrev: false,
                    arrowNext: false,
                    zoom: true,
                    close: false,
                    padding: {bottom: 120},
                    counter: false,
                    preloader: false,
                    initialZoomLevel: 'fit',
                    secondaryZoomLevel: 1,
                    maxZoomLevel: 1,
                });



                this.lightbox.addFilter('thumbEl', (thumbEl, {id}) => {
                    const activeSlide = this.gallerySwiper?.slides[this.gallerySwiper.activeIndex];
                    return activeSlide?.querySelector('img') || thumbEl;
                });

                this.lightbox.addFilter('placeholderSrc', (src, {data: {id}}) => {
                    // return activeSlide?.querySelector('img')?.src || src;
                });

                this.lightbox.on('change', () => {
                    // console.log("this.lightbox.on('change'");
                    window.pauseAllMedia?.();
                    const currIndex = this.lightbox.pswp.currIndex;
                    this.gallerySwiper.slideTo(currIndex, 100, false);
                });

                this.lightbox.on('pointerDown', (e) => {
                    if (this.lightbox.pswp.currSlide.data.mediaType !== 'image') {
                        e.preventDefault();
                    }
                });

                this.lightbox.on('uiRegister', () => {
                    if (!this.onlyImage) {
                        this.lightbox.pswp.ui.registerElement({
                            name: 'next',
                            ariaLabel: 'Next slide',
                            order: 3,
                            isButton: true,
                            html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
                            onClick: () => this.lightbox.pswp.next(),
                        });

                        this.lightbox.pswp.ui.registerElement({
                            name: 'prev',
                            ariaLabel: 'Previous slide',
                            order: 1,
                            isButton: true,
                            html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
                            onClick: () => this.lightbox.pswp.prev(),
                        });
                    }
                    this.lightbox.pswp.ui.registerElement({
                        name: 'close-zoom',
                        ariaLabel: 'Close zoom image',
                        order: 2,
                        isButton: true,
                        html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
                        onClick: () => this.lightbox.pswp.close(),
                    });

                });

                this.lightbox.init();

                this.lightbox.on('close', () => {
                    const currIndex = this.lightbox.pswp.currIndex;
                    // PhotoSwipe starts to close, unbind most events here
                    // document.getElementById("zoom-thumbnails").innerHTML = '';
                    hideThumbs("zoom-thumbnails");
                    setTimeout(() => {
                        const gallerySlides = this.gallerySwiper.slides;
                        const visibleGallery = [...gallerySlides].filter(
                            slide => !slide.classList.contains('hidden')
                        );
                        const activeThumb = visibleGallery[currIndex];
                        this.thumbsSwiper.update();
                        this.gallerySwiper.slideTo(currIndex, 100, false);
                        this.thumbsSwiper.slideTo(currIndex, 100, false);

                        if (activeThumb) {
                            activeThumb.classList.add('slider-thumb-active');
                        }

                    }, 450)
                });
                this.lightbox.on('change', () => {
                    const currIndex = this.lightbox.pswp.currIndex;
                    // console.log('Slide changed to index:', currIndex);
                    const thumbsOfAllItems = [...document.querySelectorAll('.zoom-thumbnails img')];
                    thumbsOfAllItems.forEach(img => img.classList.remove('active'));
                    if (thumbsOfAllItems[currIndex]) {
                        thumbsOfAllItems[currIndex].classList.add('active');
                    }
                    scrollActiveThumbnailIntoView()

                    function scrollActiveThumbnailIntoView() {
                        const container = document.getElementById('zoom-thumbnails');
                        const thumbnails = container.querySelectorAll('.pswp__item--image');
                        const active = container.querySelector('.pswp__item--image.active');

                        if (!active || thumbnails.length === 0) return;

                        const activeIndex = Array.from(thumbnails).indexOf(active);
                        const itemWidthWithMargin = 80;
                        const totalWidth = thumbnails.length * itemWidthWithMargin;
                        const visibleWidth = container.offsetWidth;
                        if (totalWidth > visibleWidth) {
                            const scrollPercent = activeIndex / (thumbnails.length - 1);
                            const maxScrollLeft = container.scrollWidth - container.clientWidth;
                            if (activeIndex === 0) {
                                container.scrollTo({left: 0, behavior: 'smooth'});
                            } else {
                                const scrollLeft = scrollPercent * maxScrollLeft;
                                container.scrollTo({left: scrollLeft, behavior: 'smooth'});
                            }
                        }
                    }
                });

                const thumbnailWrapper = this.closest('.thumbs-swiper') || document;
                const allThumbsMedia = [...thumbnailWrapper.querySelectorAll('.product__thumbs-item')]
                    .filter((el) => getComputedStyle(el).display !== 'none');
                let dataThumbsSource = allThumbsMedia.map((media) => {
                    const mediaType = media.dataset.mediaType;
                    console.warn("=>(media-gallery-color-variants.js:263) mediaType", mediaType);
                    let htmlOutput = "";
                    switch (mediaType) {
                        case 'image':
                            htmlOutput += `<img src="${media.dataset.src}" class="pswp__item--${mediaType}" alt="${media.dataset.name}"/>`
                            return htmlOutput;
                        case 'video':
                            htmlOutput += `<div class="relative zoom-video"><img src="${media.dataset.src}" class="pswp__item--image" alt="${media.dataset.name}"/><span class="product__thumbs-badge" aria-hidden="true"><svg class="icon icon-play icon--large " width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.6"><circle cx="77.7774" cy="77.7778" r="60" fill="black"></circle><path d="M105.416 78.2284L64.6295 101.776L64.6295 54.6803L105.416 78.2284Z" fill="#FEFBF8"></path></g></svg></span></div>`
                            return htmlOutput;
                        default:
                            return null;
                    }
                });

                FoxTheme.utils.addEventDelegate({
                    selector: '.js-photoswipe--zoom',
                    context: this,
                    handler: (e, media) => {
                        if (['image', 'eko'].includes(media.dataset.mediaType)) {
                            const index = Number(media.dataset.mediaIndex) || 0;

                            this.lightbox.loadAndOpen(index);

                            hideThumbs("zoom-thumbnails");
                            const thumbnailDiv = document.createElement('div');
                            thumbnailDiv.innerHTML = dataThumbsSource.join('') || ""
                            thumbnailDiv.classList.add('zoom-thumbnails');
                            thumbnailDiv.id = 'zoom-thumbnails';

                            const thumbs = [...document.querySelectorAll('.zoom-thumbnails img')];
                            document.body.appendChild(thumbnailDiv);
                            document.querySelector('.zoom-thumbnails').addEventListener('click', (e) => {
                                const clicked = e.target.closest('img, .zoom-video');
                                if (!clicked) return;

                                e.preventDefault();
                                const pswp = this.lightbox.pswp;

                                if (clicked.classList.contains('zoom-video')) {
                                    const thumbsOfAllItems = [...document.querySelectorAll('.zoom-thumbnails img, .zoom-thumbnails .zoom-video')];
                                    const indexOfSelectedItem = thumbsOfAllItems.indexOf(clicked);
                                    // const videoIndex = getVideoSlideIndex();
                                    if (indexOfSelectedItem !== -1) {
                                        pswp.goTo(indexOfSelectedItem);
                                    }
                                } else {
                                    const thumbsOfAllImages = [...document.querySelectorAll('.zoom-thumbnails img')];
                                    const indexOfSelectedImage = thumbsOfAllImages.indexOf(clicked);
                                    if (indexOfSelectedImage !== -1) {
                                        pswp.goTo(indexOfSelectedImage);
                                    }
                                }
                            });
                        }
                    },
                });
                function hideThumbs(elementId) {
                    var el = document.getElementById(elementId);
                    if (el) el.remove()
                }
            }

            videoPlayButton() {
                document.addEventListener('click', (e) => {
                    const playButton = e.target.closest('.custom-play-button');
                    if (playButton) {
                        const controller = playButton.closest('media-controller');
                        if (!controller) return;

                        const video = controller.querySelector('video');
                        if (!video) return;

                        if (video.paused) {
                            video.play();
                        } else {
                            video.pause();
                        }

                        video.addEventListener('play', () => {
                            playButton.classList.add('hidden');
                        });

                        video.addEventListener('pause', () => {
                            playButton.classList.remove('hidden');
                        });

                        // Başlangıçta video oynuyorsa butonu gizle
                        if (!video.paused) {
                            playButton.classList.add('hidden');
                        }
                    }
                });
            }

            initThumbsSwiper() {
                const thumbsParams = {
                    freeMode: true,
                    direction: window.innerWidth < 768 ? 'horizontal' : 'vertical',
                    slidesPerView: 4.5,
                    spaceBetween: 5,
                    mousewheel: true,
                    watchOverflow: true,
                    centeredSlides: false,
                    slideToClickedSlide: false,
                    preventClicks: true,
                    preventClicksPropagation: true,
                    touchStartPreventDefault: false,
                    navigation: window.innerWidth < 1025 ? false : {
                        nextEl: document.querySelector('.thumb-next'),
                        prevEl: document.querySelector('.thumb-prev'),
                    },
                    a11y: {
                        prevSlideMessage: 'Previous slide',
                        nextSlideMessage: 'Next slide',
                        scrollOnFocus: false,
                    },
                    breakpoints: {
                        640: {
                            direction: 'horizontal',
                            navigation:false
                        },
                        768: {
                            direction: 'horizontal',
                            navigation:false
                        },
                        1025: {
                            direction: 'horizontal',
                            navigation:false
                        },
                        1200: {
                            direction: 'vertical',
                        },
                    },
                    on: {
                        click: (swiper, event) => {
                            const clickedSlide = event.target.closest('.swiper-slide');
                            if (!clickedSlide) return;

                            const isVideoSlide = clickedSlide.getAttribute('data-media-type') === 'video';
                            const clickedIndex = swiper.slides.indexOf(clickedSlide);
                            if (clickedIndex !== -1) {
                                // swiper.slideTo(clickedIndex);
                            }
                        }
                    }
                };
                this.thumbsSwiper = new Swiper(this.thumbsSelector, thumbsParams);
            }

            initGallerySwiper() {
                const galleryParams = {
                    autoHeight: false,
                    slideActiveClass: 'slider-thumb-active',
                    lazy: true,
                    loop: false,
                    watchSlidesProgress: true,
                    navigation: {
                        nextEl: document.querySelector('.featured-slider-next'),
                        prevEl: document.querySelector('.featured-slider-prev')
                    },
                    slideToClickedSlide: false,
                    preventClicks: true,
                    preventClicksPropagation: true,
                };
                this.gallerySwiper = new Swiper(this.gallerySelector, galleryParams);
                this.gallerySwiper.on('slidesUpdated', () => {
                    this.gallerySwiper.navigation.update();
                    this.thumbsSwiper.navigation.update();
                    setTimeout(() => {
                        const activeIndex = this.gallerySwiper.realIndex;
                        if (window.innerWidth < 768) {
                            this.thumbsSwiper.slideTo(activeIndex - 1);
                        } else {
                            this.thumbsSwiper.slideTo(activeIndex - 1);
                        }
                    }, 500)
                })

                this.gallerySwiper.on('slideChangeTransitionStart', (element) => {
                    const activeIndex = this.gallerySwiper.realIndex;
                });

                this.gallerySwiper.on('slideChange', (element) => {
                    this.thumbsSwiper.update();
                    this.gallerySwiper.update();
                    const thumbsSlides = this.thumbsSwiper.slides;
                    thumbsSlides.forEach(slide => slide.classList.remove('slider-thumb-active'));
                    const currentIndex = this.gallerySwiper.activeIndex;

                    const visibleThumbs = [...thumbsSlides].filter(
                        slide => !slide.classList.contains('hidden')
                    );
                    const activeThumb = visibleThumbs[currentIndex];
                    if (activeThumb) {
                        activeThumb.classList.add('slider-thumb-active');
                    }

                    // TODO: Video Section Check it
                    const acviteVideoAction = this.gallerySwiper.activeIndex;
                    const activeSlide = this.gallerySwiper.slides[acviteVideoAction];
                    const mediaType = activeSlide.dataset.mediaType;
                    if (mediaType === 'video') {
                        this.autoplayMuted(activeSlide);    // Autoplay muted
                        // noAutoplayUnmuted(activeSlide); // No autoplay, unmuted
                    } else {
                        this.stopAllVideos();
                    }
                });


            }




            // 🎥 Tüm videoları durdur ve başa sar
            stopAllVideos() {
                const videos = document.querySelectorAll('media-controller video');
                videos.forEach(video => {
                    video.pause();
                    video.currentTime = 0;
                    video.muted = false;
                    // console.log('🔇 Video durduruldu ve sessize alındı');
                });
            }

            // ✅ Versiyon 1: Autoplay + Muted
            autoplayMuted(activeSlide) {
                const video = activeSlide.querySelector('media-controller video');
                if (video) {
                    this.stopAllVideos();

                    // Muted autoplay
                    video.muted = false;

                    // Kullanıcı tıklarsa sesi aç
                    video.addEventListener('click', function unmuteOnClick() {
                        video.muted = false;
                        // console.log('🔊 Ses açıldı (user click)');
                        video.removeEventListener('click', unmuteOnClick);
                    });
                }
            }

            // ✅ Versiyon 2: No Autoplay + Unmuted
            noAutoplayUnmuted(activeSlide) {
                const video = activeSlide.querySelector('media-controller video');
                if (video) {
                    this.stopAllVideos();

                    // Unmuted ama autoplay yok
                    video.muted = false;
                    // console.log('⏸️ Autoplay devre dışı (unmuted)');

                    // Kullanıcı oynatırsa logla
                    video.addEventListener('play', function logPlay() {
                        // console.log('▶️ Video oynatıldı (unmuted)');
                        video.removeEventListener('play', logPlay);
                    });
                }
            }

            setupThumbClickHandlers() {
                const thumbsWrapper = document.querySelector(this.thumbsSelector);
                if (!thumbsWrapper) return;
                thumbsWrapper.addEventListener('click', (e) => {
                    const thumb = e.target.closest('.swiper-slide');
                    if (!thumb || !thumb.dataset.index) return;
                    const index = parseInt(thumb.dataset.index);
                    if (!isNaN(index)) {
                        thumb.classList.add('slider-thumb-active');
                        this.gallerySwiper.slideTo(index);
                    }
                });
            }
        }
    )
}
